import { SidebarProvider, SidebarTrigger } from "@/components/ui/sidebar"
import { AppSidebar } from "@/components/app-sidebar"

interface AppLayoutProps {
  children: React.ReactNode
  title: string
  actions?: React.ReactNode
}

export function AppLayout({ children, title, actions }: AppLayoutProps) {
  return (
    <SidebarProvider>
      <div className="min-h-screen flex w-full bg-white">
        <AppSidebar />
        <main className="flex-1 p-6">
          <div className="flex items-center justify-between mb-6">
            <SidebarTrigger className="text-[#4A4A4A] hover:text-[#00ADB5]" />
          </div>
          
          <div className="flex justify-between items-center mb-8">
            <h1 className="text-2xl font-bold text-[#4A4A4A]">{title}</h1>
            {actions}
          </div>

          {children}
        </main>
      </div>
    </SidebarProvider>
  )
}